import React from 'react'
import {
  string, object, oneOf, arrayOf, func,
} from 'prop-types'
import classnames from 'classnames'
import { withI18n } from '@active/react-utils/i18n'
import './TextHr.scss'

function TextHr({
  i18n, className, id, values, background = 'white',
}) {
  const text = i18n(id, values)
  return (
    <div className={classnames(['horizontal-line', className])} style={{ background: background }}>
      <span className="line-text" style={{ background: background }}>{text}</span>
    </div>
  )
}

TextHr.propTypes = {
  i18n: func.isRequired,
  className: string,
  id: string.isRequired,
  values: oneOf([object, arrayOf(string)]),
  background: string,
}

TextHr.defaultProps = {
  className: '',
  background: 'white',
  values: null,
}

export default withI18n(TextHr)
